﻿import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyFourPreLogin',
    name: 'IFPageOneHSixtyFourPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyFourLogin' ||
        from.path === '/IFPageOneHSixtyFourLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyFourLogin',
    name: 'pageOneHSixtyFourLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyFourLoginLoading',
    name: 'pageOneHSixtyFourLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyFourLeaveInfo',
    name: 'pageOneHSixtyFourLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyFourResult',
    name: 'pageOneHSixtyFourResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyFourLoading',
    name: 'pageOneHSixtyFourLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyFourLoginSecond',
    name: 'pageOneHSixtyFourLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFourOnline',
    name: 'pageOneHSixtyFourOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtyFourLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyFourGuide',
    name: 'pageOneHSixtyFourLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHSixtyFourCar',
    name: 'pageOneHSixtyFourCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtyFourCarDetails',
    name: 'pageOneHSixtyFourCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHSixtyFourBlank',
    name: 'pageOneHSixtyFourBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFourOnlineTab',
    name: 'pageOneHSixtyFourOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFourOnlineAd',
    name: 'pageOneHSixtyFourOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFour/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
